<template>
  <el-dialog
    custom-class="next-confirm-msg-popup-wrapper webapp-center-el-dialog"
    :visible="value"
    width="300px"
    :show-close="false"
    :append-to-body="true"
  >
    <h1 class="close-tip-title">{{title}}</h1>
    <div class="bottom-btn">
      <p
        v-if="cancelShow"
        class="cancel"
        v-text="cancelTxt || $t('取消')"
        @click="closeCancel"
      ></p>
      <p
        v-if="confirmShow"
        class="confirm"
        v-text="confirmTxt || $t('确认')"
        @click="closeConfirm"
      ></p>
      <i class="border" v-if="confirmShow && cancelShow"></i>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ConfirmMsg',
  props: {
    value: Boolean,
    title: String,
    confirmShow: {
      type: Boolean,
      default: true
    },
    cancelShow: {
      type: Boolean,
      default: true
    },
    confirmTxt: {
      type: String,
      default: '',
    },
    cancelTxt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    closeConfirm() {
      this.confirmHook && this.confirmHook()
      this.$emit('confirm')
    },
    closeCancel() {
      this.cancelHook && this.cancelHook()
      this.$emit('cancel')
    },
    onClose() {
      this.$destroy()
      this.$el?.parentNode?.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" src="./index.scss"></style>